module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('ul', _vm._l((_vm.navItems), function(item) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          return _vm.addClass($event)
        },
        "mouseleave": function($event) {
          return _vm.rmClass($event)
        },
        "click": function($event) {
          return _vm.toLink(item.link, $event)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])
  }), 0)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f8b9d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 162
// module chunks = 1